var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M21.728 20.48L16 16.8l-5.728 3.68L12 13.888 6.736 9.584l6.784-.4L16 2.88l2.464 6.32 6.784.4-5.264 4.304zM28.8 12.8c0-1.76 1.44-3.2 3.2-3.2V3.2C32 1.44 30.56 0 28.8 0H3.2C1.44 0 .016 1.44.016 3.2v6.4c1.76 0 3.184 1.44 3.184 3.2A3.2 3.2 0 0 1 0 16v6.4c0 1.76 1.44 3.2 3.2 3.2h25.6c1.76 0 3.2-1.44 3.2-3.2V16a3.21 3.21 0 0 1-3.2-3.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketActivity);
export default __webpack_public_path__ + "static/media/ticket-activity.65180fd67a972a237378814c1cc8c54e.svg";
export { ForwardRef as ReactComponent };